var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDogIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 2.33317C3.07984 2.33317 2.33317 3.07984 2.33317 3.99984C2.33317 4.91984 3.07984 5.6665 3.99984 5.6665C4.91984 5.6665 5.6665 4.91984 5.6665 3.99984C5.6665 3.07984 4.91984 2.33317 3.99984 2.33317ZM3.99984 0.666504C2.15984 0.666504 0.666504 2.15984 0.666504 3.99984C0.666504 5.83984 2.15984 7.33317 3.99984 7.33317C5.83984 7.33317 7.33317 5.83984 7.33317 3.99984C7.33317 2.15984 5.83984 0.666504 3.99984 0.666504ZM3.99984 6.6665C2.5265 6.6665 1.33317 5.47317 1.33317 3.99984C1.33317 2.5265 2.5265 1.33317 3.99984 1.33317C5.47317 1.33317 6.6665 2.5265 6.6665 3.99984C6.6665 5.47317 5.47317 6.6665 3.99984 6.6665Z",
    fill: "#3961A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_1751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogIcon);
export default __webpack_public_path__ + "static/media/dog_icon.cf574c7c71c1b5d9cd8bda5bf9540bfc.svg";
export { ForwardRef as ReactComponent };